import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Checkbox from "components/DesignComponents/Checkbox";
import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import CompanyDropdown from "components/QueryDropdown/CompanyDropdown";

import { useDisabled } from "../../../hooks";
import { InitialProps } from "./types";

const Initial = ({
    isLoading,
    isChecked,
    name,
    company,
    onIsSmartGroupChange,
    onChangeName,
    onCompanyChange
}: InitialProps) => {
    const { t } = useTranslation();
    const { isRestricted } = useDisabled();

    return (
        <>
            <InputField
                data-testid="group-name-input-field"
                size={INPUT_FIELD_SIZES.Medium}
                fullWidth
                required
                readOnly={isLoading}
                value={name}
                onChange={e => onChangeName(e.target.value)}
                labelLeft={t("Dialog##name")}
                placeholder={t("Dialog##enter name")}
                customStyle={{ marginBottom: "16px" }}
            />

            {company !== undefined && (
                <CompanyDropdown
                    data-testid="company-query-dropdown"
                    value={company}
                    isRequired
                    readOnly={isLoading}
                    change={(_, val) => onCompanyChange(val)}
                    customStyle={{ marginBottom: "16px" }}
                    isRootRequired
                />
            )}

            <TooltipGeneral
                title={isRestricted ? t(`Restrictions##general message`) : ""}
                placement={TOOLTIP_PLACEMENT.Top}
            >
                <span
                    css={css({
                        display: "inline-flex",
                        marginBottom: "8px"
                    })}
                >
                    <Checkbox
                        label={t("Dialog##create smart group")}
                        checked={isChecked}
                        disabled={isRestricted || isLoading}
                        onChange={(_, isChecked) =>
                            onIsSmartGroupChange(isChecked)
                        }
                    />
                </span>
            </TooltipGeneral>
        </>
    );
};

export { Initial };
